import { literal, string, TypeOf } from 'zod';

import { ElementType } from '../common';
import { CarouselOptions } from './carousel';

/* ------------------------ VideoCarouselPageElement ------------------------ */

export const VideoCarouselPageElement = CarouselOptions.deepPartial().extend({
    id: string(),
    type: literal(ElementType.VideoCarousel),
    collectionId: string(),
});

export type VideoCarouselPageElement = TypeOf<typeof VideoCarouselPageElement>;
